import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle2 } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
export function Testimonios() {
  const testimonios = [{
    text: 'Llevaba 4 años con omeprazol todos los días. No podía dormir porque se me subía el ácido. A los 3 días de empezar el protocolo dormí completo por primera vez en meses. Estoy descansando de medicamentos. No es un milagro, es información que nadie me había dado.',
    initial: 'R',
    name: 'Roberto M.',
    loc: 'Córdoba, Argentina · 54 años',
    time: 'Hace 3 semanas',
    result: 'Descansando de medicamentos después de 4 años'
  }, {
    text: 'Tengo hernia hiatal y gastritis crónica. Es terrible sentirse con el fuego que sentía. Hugo explica exactamente qué ajustar para esta situación. En 72 horas noté menos ardor. Me he sentido muy bien. Ahora puedo comer sin miedo.',
    initial: 'M',
    name: 'María C.',
    loc: 'Buenos Aires · 47 años',
    time: 'Hace 12 días',
    result: 'Alivio en 72 horas con hernia hiatal'
  }, {
    text: 'Todo me daba ardor. Todo lo que comía me ponía mal, hasta el agua. Con la Lista Negra descubrí 3 alimentos que creía inofensivos y eran los culpables. Los eliminé y el cambio fue inmediato. Me funcionó.',
    initial: 'A',
    name: 'Ana L.',
    loc: 'Rosario, Argentina · 41 años',
    time: 'Hace 1 mes',
    result: 'Identificó 3 alimentos culpables en 1 semana'
  }, {
    text: 'Sufro mucho de gastritis. Probé vinagre de manzana, bicarbonato, sábila, jengibre... nada. Usé el mapa de detonantes y en una semana identifiqué qué me hacía daño. Hoy como variado y el reflujo bajó un 80%. Me ayudó muchísimo.',
    initial: 'P',
    name: 'Pablo R.',
    loc: 'Mendoza · 38 años',
    time: 'Hace 5 días',
    result: 'Reflujo reducido un 80% sin remedios caseros'
  }, {
    text: 'Es horrible el reflujo. Me despertaba a las 3 de la mañana con el ácido en la garganta, dolor en el pecho y la espalda. Con la rutina nocturna del protocolo eso desapareció en la primera semana. Adiós al dolor. Simple y práctico.',
    initial: 'L',
    name: 'Laura S.',
    loc: 'CABA · 52 años',
    time: 'Hace 2 semanas',
    result: 'Adiós al dolor nocturno en 1 semana'
  }, {
    text: 'El protocolo de emergencia vale el precio solo. Cuando el ardor aparece de golpe — esa agrura horrible — saber exactamente qué hacer en 10 minutos no tiene precio. Ya no tengo esa molestia. Lo recomiendo a cualquiera que sufra de reflujo.',
    initial: 'C',
    name: 'Carlos V.',
    loc: 'Tucumán · 60 años',
    time: 'Hace 8 días',
    result: 'Alivio de la agrura en 10 minutos'
  }];
  return <section id="testimonios" className="py-[100px] bg-gradient-to-b from-[#1a0f08] to-[#120806]" data-id="element-331">
      <div className="container-custom" data-id="element-332">
        <SectionHeader eyebrow="Resultados reales" title={<>
              Lo que dicen quienes ya
              <br data-id="element-334" />
              <span className="text-gold" data-id="element-335">aplicaron el protocolo</span>
            </>} data-id="element-333" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-[60px]" data-id="element-336">
          {testimonios.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: idx % 3 * 0.1
        }} className="bg-gold/5 border border-gold/15 rounded-[10px] p-[28px_24px] transition-all duration-300 hover:border-gold/30 hover:bg-gold/10 flex flex-col" data-id="element-337">
              <div className="flex justify-between items-start mb-3.5" data-id="element-338">
                <div className="flex gap-1" data-id="element-339">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-340" />)}
                </div>
                <span className="text-[11px] text-gray/70" data-id="element-341">{t.time}</span>
              </div>

              <div className="bg-gold/10 border border-gold/20 text-gold text-[12px] font-semibold px-3 py-1 rounded-full inline-block mb-3 self-start" data-id="element-342">
                ✦ {t.result}
              </div>

              <p className="text-[14px] text-gray-light leading-[1.7] mb-6 italic flex-1" data-id="element-343">
                "{t.text}"
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-gold/10" data-id="element-344">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gold to-gold-light flex items-center justify-center font-bold text-[15px] text-deep shrink-0" data-id="element-345">
                  {t.initial}
                </div>
                <div data-id="element-346">
                  <div className="flex items-center gap-1.5" data-id="element-347">
                    <p className="text-[13px] font-semibold text-white" data-id="element-348">
                      {t.name}
                    </p>
                    <CheckCircle2 className="w-3.5 h-3.5 text-green-500" data-id="element-349" />
                  </div>
                  <p className="text-[11px] text-gray mt-0.5" data-id="element-350">{t.loc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="flex justify-center gap-8 md:gap-[60px] mt-[60px] pt-[48px] border-t border-gold/15 flex-wrap" data-id="element-351">
          <div className="text-center" data-id="element-352">
            <div className="font-display text-[40px] font-black bg-gradient-to-r from-gold to-gold-light bg-clip-text text-transparent leading-none mb-1.5" data-id="element-353">
              +1.200
            </div>
            <div className="text-[12px] text-gray tracking-[0.5px]" data-id="element-354">
              Personas que aplicaron el protocolo
            </div>
          </div>
          <div className="text-center" data-id="element-355">
            <div className="font-display text-[40px] font-black bg-gradient-to-r from-gold to-gold-light bg-clip-text text-transparent leading-none mb-1.5" data-id="element-356">
              72h
            </div>
            <div className="text-[12px] text-gray tracking-[0.5px]" data-id="element-357">
              Tiempo promedio para sentir resultados
            </div>
          </div>
          <div className="text-center" data-id="element-358">
            <div className="font-display text-[40px] font-black bg-gradient-to-r from-gold to-gold-light bg-clip-text text-transparent leading-none mb-1.5" data-id="element-359">
              98%
            </div>
            <div className="text-[12px] text-gray tracking-[0.5px]" data-id="element-360">
              Tasa de satisfacción reportada
            </div>
          </div>
          <div className="text-center" data-id="element-361">
            <div className="font-display text-[40px] font-black bg-gradient-to-r from-gold to-gold-light bg-clip-text text-transparent leading-none mb-1.5" data-id="element-362">
              4.9/5
            </div>
            <div className="text-[12px] text-gray tracking-[0.5px]" data-id="element-363">
              Calificación promedio
            </div>
          </div>
        </div>
      </div>
    </section>;
}